import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { wapi } from "@/lib/api";

export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false); // ref: processamento único (StrictMode-safe neste fluxo de troca única)
  const [error, setError] = useState("");

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(window.location.hash.slice(1)).get("session_id");
    if (!sessionId) {
      navigate("/trabalhadores", { replace: true });
      return;
    }
    wapi.post("/auth/session", { session_id: sessionId })
      .then((r) => {
        window.history.replaceState(null, "", "/trabalhadores");
        navigate("/trabalhadores", { replace: true, state: { user: r.data.user } });
      })
      .catch((e) => {
        window.history.replaceState(null, "", "/trabalhadores");
        if (e?.response?.status === 403) {
          setError(e.response.data?.detail || "Esta área é reservada à equipe do Estesia.");
        } else {
          setError("Não foi possível concluir o login. Tente novamente.");
        }
      });
  }, [navigate]);

  return (
    <div className="min-h-screen bg-background text-foreground grid place-items-center px-6">
      <div className="text-center max-w-md">
        {error ? (
          <>
            <h1 className="font-serif text-2xl md:text-3xl">Área dos Trabalhadores</h1>
            <p className="mt-4 font-sans text-base leading-relaxed text-muted-foreground" data-testid="auth-denied">{error}</p>
            <button
              onClick={() => navigate("/trabalhadores", { replace: true })}
              className="mt-8 rounded-full border border-primary/40 px-6 py-3 font-sans text-sm text-primary hover:bg-primary/10 transition-colors"
              data-testid="auth-back"
            >
              Voltar
            </button>
          </>
        ) : (
          <p className="font-sans text-base text-muted-foreground">Entrando…</p>
        )}
      </div>
    </div>
  );
}
